"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SectionTitle = styled_components_1.default.div `
  padding-bottom: 20px;
  padding-top: 30px;
`;
const styles = (theme) => ({
    root: {
        minWidth: theme.defaults.content.pageMinWidth,
    },
    sectionTitle: {
        marginBottom: 12,
    },
    paperRoot: {
        margin: '0 auto',
    },
    listItem: {
        paddingLeft: 20,
    },
    listItemText: {
        fontSize: 13,
    },
    selects: {
        marginRight: 16,
    },
    underConstructionContainer: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: 271,
        justifyContent: 'center',
        alignItems: 'center',
    },
    navMenuItem: {
        display: 'inline-block',
        '& img': {
            width: 35,
            display: 'inline-block',
            verticalAlign: 'middle',
        },
    },
    titleText: {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginLeft: 5,
        fontWeight: 200,
        color: '#616161',
    },
    imgUnderConstruction: {
        width: '80%',
    },
});
exports.default = styles;
